<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <!-- <el-form-item label="回收员" prop="wlUserId">
          <el-select
            v-model="queryParam.wlUserId"
            clearable
            filterable
            remote
            :remote-method="recyclerRemoteMethod"
            :loading="recyclerLoading"
          >
            <el-option
              v-for="item in recyclerOpts"
              :key="item.wlUserId"
              :label="item.name"
              :value="item.wlUserId"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="订单号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.orderNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="分拣员">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.sorterName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核人" v-if="tabIdx == 1">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.auditName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div class="selectBox" v-if="tabIdx == 1">
          <span class="selectText">状态</span>
          <el-select
            v-model="queryParam.status"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="请选择" value></el-option>
            <el-option label="通过" value="2"></el-option>
            <el-option label="拒绝" value="3"></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">创建时间</span>
          <el-date-picker
            size="mini"
            v-model="createTime"
            @change="createTimeChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
        <div class="selectBox" v-if="tabIdx == 1">
          <span class="selectText">审核时间</span>
          <el-date-picker
            size="mini"
            v-model="auditTime"
            @change="auditTimeChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待审批列表" name="first"> </el-tab-pane>
      <el-tab-pane label="已审批列表" name="second"> </el-tab-pane>
    </el-tabs>

    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #status="slotData">
        <p v-if="slotData.data.row.status == 1">待审核</p>
        <p v-if="slotData.data.row.status == 2">通过</p>
        <p v-if="slotData.data.row.status == 3">拒绝</p>
      </template>
      <template #photo="slotData">
        <div v-if="slotData.data.row.picUrl.length > 2">
          <el-image
            style="width: 100px; height: 50px; margin-right: 10px"
            :src="slotData.data.row.picUrl[0]"
            :preview-src-list="slotData.data.row.picUrl"
          >
          </el-image>
          <el-image
            style="width: 100px; height: 50px"
            :src="slotData.data.row.picUrl[1]"
            :preview-src-list="slotData.data.row.picUrl"
          >
          </el-image>...
        </div>
        <div v-if="slotData.data.row.picUrl.length && slotData.data.row.picUrl.length <= 2">
          <el-image
            style="width: 100px; height: 50px; margin-right: 10px"
            :src="slotData.data.row.picUrl[0]"
            :preview-src-list="slotData.data.row.picUrl"
          >
          </el-image>
        </div>
        <!-- <div v-if="slotData.data.row.picUrl.length > 2">
          <el-image
            style="width: 100px; height: 50px"
            :src="slotData.data.row.picUrl[0]"
            :preview-src-list="slotData.data.row.picUrl"
          >
            <div
              slot="error"
              class="image-slot"
              style="width: 100px; height: 50px"
            >
              <img
                src="@/assets/imgFail.png"
                alt
                style="width: 60px; height: 40px"
              />
            </div>
          </el-image>
        </div> -->
        <span style="color: gray" v-if="!slotData.data.row.picUrl.length">暂无</span>
      </template>
      <template #handlerSlot="slotData">
        <el-button size="mini" @click="recycleSortAudit(slotData.data.row)"
          >审批</el-button
        >
        <!-- <el-button v-if="slotData.data.row.status == 2" type="danger" size="mini" @click="audit('-1', slotData.data.row.$index, slotData.data.row)">拒绝</el-button> -->
      </template>
    </e-table>

    <el-dialog
      title="审批"
      :visible.sync="dialogFormVisible"
      @close="chareBackCancel()"
    >
      <el-form :model="form">
        <el-descriptions
        class="margin-top"
        title="订单详情"
        :column="3"
        border
      >
        <el-descriptions-item>
          <template slot="label">
            订单总额：
          </template>
          {{form.orderTotalPrice}} 环保金
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            订单实际重量：
          </template>
          {{form.orderActualWeight}} kg
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            审批记录
          </template>
          {{form.auditCount}} 条
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            订单预约时间：
          </template>
          {{form.appointmentTimeBegin}}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
          </template>
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
          </template>
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            用户电话
          </template>
          {{form.phone}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            累计扣减次数
          </template>
          {{form.deductionNum}} 次
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            用户是否需要通知
          </template>
          {{ deductionStatusCode[form.deductionStatus] }}
        </el-descriptions-item>
      </el-descriptions>
        <el-form-item label="申请时间">
          <el-input
            :value="form.createTime"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="分拣员">
          <el-input
            :value="form.sorterName"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="溯源码">
          <el-input
            :value="form.traceabilityCode"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="错误重量(kg)">
          <el-input
            :value="form.errorWeight"
            v-model="form.errorWeight"
            maxlength="5"
            autocomplete="off"
            @change = "errorWeightChange"
          ></el-input>
        </el-form-item>
        <el-form-item label="单价环保金">
        <el-select
            v-model="form.unitPrice"
            placeholder="请选择"
            @change = "unitPriceChange"
            style = "display: block;"
          ><el-option label="0.1环保金" value="0.1"></el-option>
          <el-option label="0.5环保金" value="0.5"></el-option>
          <el-option label="0.6环保金" value="0.6"></el-option>
            <el-option label="0.8环保金" value="0.8"></el-option>
            <el-option label="1.2环保金" value="1.2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="总环保金">
          <el-input
            :value="form.totalPrice"
            v-model="form.totalPrice"
            disabled
            autocomplete="off"
            name = "totalPrice"
          ></el-input>
        </el-form-item>
        <el-form-item label="回收照片">
          <template v-if="form.picUrl">
            <el-image
              v-for="(item, i) in form.picUrl"
              style="width: 100px; height: 50px; margin-right: 10px"
              :src="item"
              :preview-src-list="[item]"
              :key="i"
            >
              <div
                slot="error"
                class="image-slot"
                style="width: 100px; height: 50px;"
              >
                <img
                  src="@/assets/imgFail.png"
                  alt
                  style="width: 60px; height: 40px;"
                />
              </div>
            </el-image>
          </template>
        </el-form-item>
        <el-form-item label="备注" prop="sysRemark">
          <el-input
            v-model="form.applyRemark"
            type="textarea"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div
          class="dialog_title"
          style="border-top: 1px solid #000; padding-top: 20px"
        >
          审批
        </div>
        <el-form-item label="审批结果" required>
          <el-radio-group v-model="form.status">
            <el-radio :label="2">通过</el-radio>
            <el-radio :label="3">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批意见">
          <el-input v-model="form.auditRemark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="audit()">提 交</el-button>
        <el-button @click="chareBackCancel()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRecyclertList } from "@/api/sign";
import { httpAction } from "@/api/manage";

import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable },
  mixins: [listMixin],
  props: {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  data() {
    return {
      createTime: "",
      auditTime: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      url: {
        list: "/recycleSortAudit/queryPage",
      },
      activeName: "first",
      tabIdx: 0,
      //字段权限
      columns: [
        {
          field: "traceabilityCode",
          label: "溯源码",
        },
        {
          field: "orderNo",
          label: "订单号",
        },
        {
          field: "errorWeight",
          label: "错误重量",
        },
        {
          field: "unitPrice",
          label: "单价环保金",
        },
        {
          field: "totalPrice",
          label: "总环保金",
        },
        {
          field: "sorterName",
          label: "分拣员名称",
        },
        {
          field: "applyRemark",
          label: "扣除备注",
        },
        {
          width: 300,
          label: "图片",
          slotName: "photo",
          columnType: "slot",
        },
        {
          field: "createTime",
          label: "申请时间",
        },
        {
          width: 160,
          label: "编辑",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      recyclerOpts: [],
      recyclerLoading: false,
      dialogFormVisible: false,
      form: { auditRemark: "" },
      deductionStatusCode: {
        0: "否",
        1: "是"
      },
      unitPriceOpts: [{
          value: '0.1',
          label: '0.1'
        }, {
          value: '0.8',
          label: '0.8'
        }, {
          value: '1.2',
          label: '1.2'
        }],
        value: ''
    };
  },
  watch: {},
  computed: {},
  methods: {
    createTimeChange(date) {
      if (date) {
        this.queryParam.createTimeStart = date[0] + " 00:00:00";
        this.queryParam.createTimeEnd = date[1] + " 23:59:59";
      } else {
        this.queryParam.createTimeStart = "";
        this.queryParam.createTimeEnd = "";
      }
    },
    auditTimeChange(date) {
      if (date) {
        this.queryParam.auditTimeStart = date[0] + " 00:00:00";
        this.queryParam.auditTimeEnd = date[1] + " 23:59:59";
      } else {
        this.queryParam.auditTimeStart = "";
        this.queryParam.auditTimeEnd = "";
      }
    },
    searchReset() {
      this.queryParam = {};
      this.createTime = "";
      this.auditTime = "";
      this.searchQuery();
    },
    handleClick(tab, event) {
      if (tab.index == 0 && this.tabIdx == 0) return;
      if (tab.index == 1 && this.tabIdx == 1) return;
      this.queryParam = {};
      if (tab.index == 0) {
        this.url.list = "/recycleSortAudit/queryPage";
        this.tabIdx = 0;
        this.columns = [
          {
            field: "traceabilityCode",
            label: "溯源码",
          },
          {
            field: "orderNo",
            label: "订单号",
          },
          {
            field: "errorWeight",
            label: "错误重量",
          },
          {
            field: "unitPrice",
            label: "单价环保金",
          },
          {
            field: "totalPrice",
            label: "总环保金",
          },
          {
            field: "sorterName",
            label: "分拣员名称",
          },
          {
            field: "applyRemark",
            label: "扣除备注",
          },
          {
            width: 300,
            label: "图片",
            slotName: "photo",
            columnType: "slot",
          },
          {
            field: "createTime",
            label: "创建时间",
          },
          {
            width: 160,
            label: "编辑",
            slotName: "handlerSlot",
            columnType: "slot",
          },
        ];
      } else if (tab.index == 1) {
        this.url.list = "/recycleSortAudit/auditQueryPage";
        this.tabIdx = 1;
        this.columns = [
          {
            field: "traceabilityCode",
            label: "溯源码",
          },
          {
            field: "orderNo",
            label: "订单号",
          },
          {
            field: "errorWeight",
            label: "错误重量",
          },
          {
            field: "unitPrice",
            label: "单价环保金",
          },
          {
            field: "totalPrice",
            label: "总环保金",
          },
          {
            field: "sorterName",
            label: "分拣员名称",
          },
          {
            field: "applyRemark",
            label: "扣除备注",
          },
          {
            field: "createTime",
            label: "创建时间",
          },
          {
            field: "status",
            label: "状态",
            slotName: "status",
            columnType: "slot",
          },
          {
            field: "auditName",
            label: "审核人名称",
          },
          {
            field: "auditRemark",
            label: "审核备注",
          },
          {
            field: "auditTime",
            label: "审核时间",
          },
          {
            width: 300,
            label: "图片",
            slotName: "photo",
            columnType: "slot",
          },
          // {
          //   width: 160,
          //   label: "编辑",
          //   slotName: "handlerSlot",
          //   columnType: "slot",
          // },
        ];
      }
      this.loadData(1);
    },
    recycleSortAudit(row) {
      httpAction("/recycleSortAudit/detail?id=" + row.id, {}, "get").then(
        (res) => {
          if (res.code == 200) {
            this.form = res.data;
            this.dialogFormVisible = true;
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    errorWeightChange(value) {
      this.form.totalPrice = parseFloat((value * this.form.unitPrice).toFixed(2));
    },
    unitPriceChange(value) {
      this.form.totalPrice = parseFloat((value * this.form.errorWeight).toFixed(2));
    },
    audit() {
      if (this.form.status != 2 && this.form.status != 3)
        return this.$message.error("请选择审核结果");
      httpAction("/recycleSortAudit/audit", { ...this.form }, "post").then(
        (res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.chareBackCancel();
            this.loadData(1);
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    chareBackCancel() {
      this.dialogFormVisible = false;
      this.form = { auditRemark: "" };
    },
    recyclerRemoteMethod(name) {
      if (name !== "") {
        this.recyclerLoading = true;
        getRecyclertList({ name, pageNo: 1, pageSize: 999 }).then((res) => {
          this.recyclerOpts = res.data.records;
          this.recyclerLoading = false;
        });
      } else {
        this.recyclerOpts = [];
        this.recyclerLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
::v-deep .el-dialog__body {
  padding-top: 10px;
}
.dialog_title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
